import "./App.css";
import "./admin.css";
import "./start.css";
import "./countrySelector.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CountrySelector from "./pages/CountrySelector";
import LandingPage from "./pages/LandingPage";
import AdminPanel from "./pages/AdminPanel";
import AdminLogin from "./pages/AdminLogin";
import India from "./pages/India";
import IndiaPage from "./pages/IndiaPage";
import Hrvatski from "./pages/Hrvatski";
import USA from "./pages/USA";
import Espanol from "./pages/Espanol";
import Start from "./pages/Start";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import PrivacyPolicyES from "./pages/PrivacyPolicyES";
import PrivacyPolicyRO from "./pages/PrivacyPolicyRO";
import HindiForm from "./pages/HindiForm";
import ProtectedRoute from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CountrySelector />} />
          <Route path="/romania" element={<LandingPage />} />
          <Route path="/espanol" element={<Espanol />} />
          <Route path="/english" element={<USA />} />
          <Route path="/hrvatski" element={<Hrvatski />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/privacy-es" element={<PrivacyPolicyES />} />
          <Route path="/privacy-ro" element={<PrivacyPolicyRO />} />
          <Route path="/hindi-form" element={<HindiForm />} />
          <Route path="/start" element={<Start />} />
          <Route path="/hindi" element={<IndiaPage />} />
          <Route path="/india" element={<IndiaPage />} />
          <Route path="/croatia" element={<Hrvatski />} />
          <Route path="/usa" element={<USA />} />
          <Route path="/mexico" element={<India />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute>
                <AdminPanel />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
